document.addEventListener('DOMContentLoaded', function () {


    // Simple Variant Validation on Add to Cart Click
    document.addEventListener('click', function(event) {
        // Check if clicked element is the add to cart button
        const button = event.target.closest('button[type="submit"].button--secondary');
        
        if (button) {
            // Check if any variant radio button is checked
            const checkedVariant = document.querySelector('input[type="radio"][data-option-position="1"]:checked');
            
            if (!checkedVariant) {
            // Prevent the default action
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            
            // Show alert
            alert('⚠️ Please select your size.');
            
            // Optional: Highlight the variant section
            const variantSection = document.querySelector('.variant-picker__option-values');
            if (variantSection) {
                variantSection.style.border = '2px solid red';
                variantSection.style.padding = '10px';
                variantSection.style.borderRadius = '5px';
                
                // Remove highlight after 3 seconds
                setTimeout(function() {
                variantSection.style.border = '';
                variantSection.style.padding = '';
                }, 3000);
            }
            
            return false;
            }
        }
    }, true);

 document.addEventListener('click', function (e) {
    const label = e.target.closest('label.block-swatch');
    if (!label) return;

    const radioId = label.getAttribute('for');
    if (!radioId) return;
    setTimeout(() => {
      const radio = document.getElementById(radioId);
      if (!radio) return;

      // ONLY set attribute (no event trigger)
      radio.setAttribute('checked', 'checked');
    }, 1000); // 1 second delay as requested
  });

const isVariantSelected = () => {
  return document.querySelector(
    '.variant-picker__option-values input[type="radio"]:checked'
  );
};

const isSoldOut = () => {
  const addToCartBtn = document.querySelector(
    'form[id^="product-form"] button[type="submit"]'
  );

  if (!addToCartBtn) return true;

  // Sold out if Add to Cart is disabled
  if (addToCartBtn.hasAttribute('disabled')) return true;

  // Text fallback
  const text = addToCartBtn.innerText.toLowerCase();
  if (text.includes('sold out')) return true;

  return false;
};

const updateBuyNowState = () => {
  const buyNowBtn = document.getElementById('gokwik-buy-now');
  if (!buyNowBtn) return;

  if (isVariantSelected() && !isSoldOut()) {
    // SHOW Buy Now
    buyNowBtn.style.display = '';
  } else {
    // HIDE Buy Now
    buyNowBtn.style.display = 'none';
  }
};


  // Observe body for Buy Now button injection
  const bodyObserver = new MutationObserver(() => {
    updateBuyNowState();
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Listen for variant changes
  document.addEventListener('change', function (e) {
    if (e.target.matches('.variant-picker__option-values input[type="radio"]')) {
      updateBuyNowState();
    }
  });

  //Initial check
  updateBuyNowState();

  
  





  

});
